import React, { useState, useEffect } from 'react';
import Image from '../banner.jpg'
import axios from 'axios'
import { Oval } from 'react-loader-spinner';
import Pagination from './Pagination';

function Movies() {
    let genreids = {
        28: 'Action',
        12: 'Adventure',
        16: 'Animation', 35: 'Comedy', 80: 'Crime', 99: 'Documentary', 18: 'Drama', 10751: 'Family', 14: 'Fantasy', 36: 'History',
        27: 'Horror', 10402: 'Music', 9648: 'Mystery', 10749: 'Romance', 878: 'Sci-Fi', 10770: 'TV', 53: 'Thriller', 10752: 'War', 37: 'Western'
      }

    const [movies, setMovies] = useState([])   //for fetching the movie
    const [page, setPage] = useState(1)
    const [hover, setHover] = useState('') 
    const [favourites, setFavourites] = useState([])
    const [show,setShow]=useState();

    function goAhead() {
        setPage(page + 1)
    }
    function goBack() {
        if (page > 1) {
            setPage(page - 1)
        }
    }
    useEffect(function () {
        // everytime when page reloads
        let oldFav = localStorage.getItem("imdb");
        oldFav = JSON.parse(oldFav) || [];
        console.log(oldFav);
        // setFavourites(oldFav);
        // data manga 
        axios.get(`https://api.themoviedb.org/3/trending/movie/week?api_key=5540e483a20e0b20354dabc2d66a31c9&page=${page}`).then((res) => {
            console.table(res.data.results)
            setMovies(res.data.results);
        }
        )


    }, [page])

    let add = (movie) => {
        let newArray = [...favourites, movie]
        setFavourites([...newArray])
        // console.log(newArray)
        // after for reload 
        localStorage.setItem("imdb", JSON.stringify(newArray))
    }

    let del = (movie) => {
        let newArray = favourites.filter((m) => m.id != movie.id)
        setFavourites([...newArray])
        localStorage.setItem("imdb", JSON.stringify(newArray))
    }

    return <>
        <div className="mb-8 text-center">
            <div className="mt-8 mb-8 font-bold text-2xl text-center">Trending Movies</div>
            {
                movies.length == 0 ?
                    <div className='flex justify-center'>
                        <Oval
                            heigth="100"
                            width="100"
                            color='grey'
                            secondaryColor='grey'
                            ariaLabel='loading'
                        />
                    </div> :
                    <div className="flex flex-wrap justify-center">
                        {


                            movies.map((movie) => (
                                <div className={`
                                    bg-[url(https://image.tmdb.org/t/p/w500/${movie.backdrop_path})] 
                                    md:h-[30vh] md:w-[250px] 
                                    h-[25vh] w-[150px]
                                    bg-center bg-cover
                                    rounded-xl
                                    flex items-end
                                    m-4
                                    hover:scale-110
                                    ease-out duration-300
                                    relative
                                `}
                                    onMouseEnter={() => {
                                        setHover(movie.id)
                                    }}

                                    onMouseLeave={() =>
                                        setHover("")}
                                >
                                    {

                                        hover == movie.id && <>{
                                            !favourites.find((m) => m.id == movie.id) ?
                                                <div className='absolute bottom right-1
                                    p-2
                                    bg-gray-800
                                    rounded-lg
                                    text-xl
                                    cursor-pointer
                                    '
                                                    onClick={() => add(movie)}
                                                >😍</div> :
                                                <div className='absolute bottom right-1
                                    p-2
                                    bg-gray-800
                                    rounded-lg
                                    text-xl
                                    cursor-pointer
                                    '
                                                    onClick={() => del(movie)}
                                                >❌</div>
                                        
                                               
        
                                                    
                                                }


                                            
                                        
                                        
                                    


                                        </>
                                    }
                                      
                                     
                                    <div className="w-full bg-gray-900 text-white py-2 font-bold text-center rounded-b-xl">{movie.title}</div>
                                    <div className="w-full bg-gray-900 text-white  font-bold text-center rounded-b-xl top-0 absolute">{genreids[movie.genre_ids[0]]}</div>


                                </div>
                            ))
                        }

                    </div>
            }

        </div>
        {/* connecting and passing the value to the pagination */}
        <Pagination pageProp={page} goBack={goBack} goAhead={goAhead} />
    </>
}

export default Movies;